import i18n from '@/utils/i18n';
import React from 'react';
import { Card, Skeleton, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { InsightCardHeaderSkeleton } from '@/experiences/sales-portal/domain/insights/components/insight-card-header-skeleton';
import { useTheme } from '@/contexts/theme-context';

const ROW_COUNT = 5;
const ROW_AVATAR_SIZE = 32;
const ROW_TITLE_HEIGHT = 22; // -2px to account for spacing
const ROW_SUBTITLE_HEIGHT = 16; // -2px to account for spacing
const ROW_VALUE_HEIGHT = 22;
const ROW_VALUE_WIDTH = 56;

export const LowestPerformingCustomersCardSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Card
      accessibilityLabel={i18n.t('loading')}
      accessibilityState={{ busy: true }}
      flex={1}
      gap="$16"
    >
      <InsightCardHeaderSkeleton />
      <YStack flex={1} gap="$16" paddingBottom="$8">
        {Array.from({ length: ROW_COUNT }, (_, index) => (
          <XStack alignItems="center" gap="$12" key={index}>
            <Skeleton
              height={ROW_AVATAR_SIZE}
              variant="circle"
              width={ROW_AVATAR_SIZE}
            />
            <XStack alignItems="flex-start" flex={1}>
              <YStack flex={1} gap="$4">
                <Skeleton
                  borderRadius={theme.sk.radii.radiusRound}
                  height={ROW_TITLE_HEIGHT}
                  variant="rect"
                  width="70%"
                />
                <Skeleton
                  borderRadius={theme.sk.radii.radiusRound}
                  height={ROW_SUBTITLE_HEIGHT}
                  variant="rect"
                  width="50%"
                />
              </YStack>
              <Skeleton
                borderRadius={theme.sk.radii.radiusRound}
                height={ROW_VALUE_HEIGHT}
                variant="rect"
                width={ROW_VALUE_WIDTH}
              />
            </XStack>
          </XStack>
        ))}
      </YStack>
    </Card>
  );
};
